export const AUTH_BASE = 'auth/AUTH_BASE';
export const AUTHENTICATING = 'auth/AUTHENTICATING';
export const AUTH_SUCCESS = 'auth/AUTH_SUCCESS';
export const AUTH_ERROR = 'auth/AUTH_ERROR';
